import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "components/sales/downloadDocView/documentView";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import "./generate_link.css";
import { Fragment } from "react";

const GenerateLink = ({
  match,
  getDataForDropdown,
  getDropdownDatas = [],
  generateLinkForOnboarding,
  onboardingLinkForEmployee = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({
    phone_number: "",
    vendor_name: "",
    city_id: "",
    department_id: "",
    designation_id: "",
    employee_type: "",
    role_id: 80,
  });
  const [isModal, setIsModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [buttonEnable, setButtonEnable] = useState(false);
  const [registerationLink, setRegisterationLink] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getDataForDropdown();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const today = new Date();
  const minDate = new Date(today);
  minDate.setDate(today.getDate() - 2);
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 2);

  const handleModalHide = () => {
    setIsModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  useEffect(() => {
    formData['department_id'] = getDropdownDatas?.response?.data?.department_id;
    formData['role_id'] = 80;
    const allFieldsFilled =
      formData?.city_id &&
      formData?.phone_number &&
      formData?.department_id &&
      formData?.employee_type &&
      formData?.vendor_name &&
      formData?.role_id;

    setButtonEnable(!!allFieldsFilled);
  }, [formData]);


  const handleGenerateLink = async () => {
    formData["role_id"] = 80;
    formData['department_id'] = getDropdownDatas?.response?.data?.department_id
    setIsLoading(true);
    const res = await generateLinkForOnboarding(formData);
    if (res?.status == 200) {
      setSuccessMessage(res?.message);
      setRegisterationLink(res?.data);
      setIsModal(true);
    } else {
      toast.error(res.message);
    }
    setIsLoading(false);
  };

  return (
    <Layout title={"Generate Link"} isGoback isLoading={isLoading}>
      <div className="d-flex flex-wrap" style={{ minHeight: "80vh" }}>
        {/* Left side - Form */}
        <div
          className="p-5 d-flex flex-column justify-content-start"
          style={{ flex: "1", maxWidth: "50%" }}
        >
          <h2 className="fw-bold mb-4">
            Generate onboarding form for off-roll employees
          </h2>
          <ConstantInput
            label={localization.employeeMobileNumber}
            errorMsg={localization.required}
            maxLength={10}
            type="number"
            required
            isStarRequired={true}
            handleChange={(value) => {
              setData({ ...formData, phone_number: value });
            }}
          />

          <DropDownInput
            label={localization.vendor}
            required
            isStarRequired={true}
            data={[
              { id: "Workex", name: "Workex" },
              { id: "Checkmate", name: "Checkmate" },
              { id: "Ptap", name: "Ptap" },
              { id: "GDX", name: "GDX" },
              { id: "Planet PCI", name: "Planet PCI" },
              { id: "Whiteforce", name: "Whiteforce" },
              { id: "SSOS", name: "SSOS" },
              { id: "Direct", name: "Direct" },
              { id: "N/A", name: "N/A" }
            ]}
            getIdValue={(val) => setData({ ...formData, vendor_name: val.id })}
          />
          <DropDownInput
            data={getDropdownDatas?.response?.data?.employee_types}
            label={localization.employeeType}
            required
            getIdValue={(val) => {
              setData({ ...formData, employee_type: val.id });
            }}
            errorMsg={localization.required}
            isStarRequired={true}
          />

          <DropDownInput
            label={'Hiring Location'}
            required
            data={getDropdownDatas?.response?.data?.locations}
            isStarRequired={true}
            errorMsg={localization.required}
            getIdValue={(val) => {
              setData({ ...formData, city_id: val.id });
            }}
          />

          <DropDownInput
            label={localization.designation}
            required
            data={getDropdownDatas?.response?.data?.designations}
            isStarRequired={true}
            errorMsg={localization.required}
            getIdValue={(val) => {
              setData({ ...formData, designation_id: val.id });
            }}
          />

          <ConstantInput
            label={localization.department}
            errorMsg={localization.required}
            type="text"
            required
            isStarRequired={true}
            value={getDropdownDatas?.response?.data?.department_name}
            disabled={true}
          />

          {/* <ConstantInput
            label={localization.role}
            errorMsg={localization.required}
            maxLength={10}
            type="text"
            required
            isStarRequired={true}
            value={"Off-role employee"}
            disabled={true}
          /> */}

          <button
            className="my-button"
            disabled={!buttonEnable || isLoading}
            onClick={handleGenerateLink}
          >
            {isLoading ? "Sending..." : "Send form link by SMS"}
          </button>
        </div>

        {/* Right side - Image */}
        <div
          className="p-4 d-flex align-items-center justify-content-center"
          style={{ flex: "1", backgroundColor: "#F9F6FF" }}
        >
          <img
            src={Images?.OffroleEmployee || "/assets/images/offrole-form.png"}
            alt="Park+ Form Illustration"
            style={{ width: "70%", maxWidth: "500px" }}
          />
        </div>
      </div>

      {isModal && (
        <div className="modal-overlay">
          <div className="custom-modal">
            <button className="close-button" onClick={handleModalHide}>
              ×
            </button>
            <div className="success-icon">✅</div>
            <h3 style={{ textAlign: "center" }}>{successMessage}</h3>
            <div className="info-box" style={{ textAlign: "center" }}>
              <p>
                👉🏻 <strong>Next step</strong> 👈🏻
              </p>
              <p>
                Please ask the applicant to fill the registration form received
                on SMS.
                <br />
                Alternatively, please share this link with them:
              </p>
              <a
                href={registerationLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {registerationLink}
              </a>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default GenerateLink;
